module.exports = __webpack_public_path__ + "img/thumbnail_BorneanElephant_j_normal.5ada50c4.png";